// images
import blogImg1 from "../images/blog/img-1.jpg";
import blogImg2 from "../images/blog/img-2.jpg";
import blogImg3 from "../images/blog/img-3.jpg";

import cloud1 from "../../src/images/faxian-it-images/cloud-1.jpg"
import cloud2 from "../../src/images/faxian-it-images/cloud-3.jpg"
import cloud3 from "../../src/images/faxian-it-images/cloud-4.jpg"
import cloud4 from "../../src/images/faxian-it-images/cloud-5.jpg"

import recent1 from "../images/recent-posts/img-1.jpg";
import recent2 from "../images/recent-posts/img-2.jpg";
import recent3 from "../images/recent-posts/img-3.jpg";


import blogSingleImg1 from "../images/blog/1.jpg";
import blogSingleImg2 from "../images/blog/2.jpg";
import blogSingleImg3 from "../images/blog/3.jpg";



const blogs = [
    {
        id: '1',
        title: 'Salesforce',
        catagory: 'Salesforce',
        slug: '1',
        description: 'Smarter Customer Connections – Drive customer success with tailored Salesforce solutions, from setup to ongoing support.',
        create_at: 'Sep 03, 2024',
        name:"Anne William",
        screens: cloud1,
        recent: recent1,
        blogSingleImg: blogSingleImg1,
        comment: '35',
        day: '28',
        month: 'AUGUST',
        blClass: 'format-standard-image',
        animation: '1200',
    },
    {
        id: '2',
        title: 'ServiceNow',
        catagory: 'ServiceNow',
        slug: '2',
        description: 'It has survived not only five but also the leap intona electronic typesetting remaining unchanged.',
        create_at: 'Sep 06, 2024',
        name:"Anne William",
        screens: cloud2,
        recent: recent2,
        blogSingleImg: blogSingleImg2,
        comment: '35',
        day: '28',
        month: 'AUGUST',
        blClass: 'format-standard-image',
        animation: '1200',
    },
 
    {
        id: '3',
        title: 'AWS',
        catagory: 'AWS',
        slug: '3',
        description: 'It has survived not only five but also the leap intona electronic typesetting remaining unchanged.',
        create_at: 'Sep 06, 2024',
        name:"Anne William",
        screens: cloud3,
        recent: recent3,
        blogSingleImg: blogSingleImg3,
        comment: '35',
        day: '28',
        month: 'AUGUST',
        blClass: 'format-standard-image',
        animation: '1200',
    },
 
    {
        id: '4',
        title: 'Azure',
        catagory: 'Azure',
        slug: '4',
        description: 'It has survived not only five but also the leap intona electronic typesetting remaining unchanged.',
        create_at: 'Sep 06, 2024',
        name:"Anne William",
        screens: cloud4,
        recent: recent3,
        blogSingleImg: blogSingleImg3,
        comment: '35',
        day: '28',
        month: 'AUGUST',
        blClass: 'format-standard-image',
        animation: '1200',
    },
 
 
   

];
export default blogs;